import { ImageProcessorParams } from "./serialize-query-parameters";
import { calculateResolutionSize } from "@components/Image/UmbracoImage/UmbracoImage";
import { FocalPoint } from "@helpers/interfaces/image";

export const generateImageProcessorParamsWithWidthAndHeight = (
  breakpointIndex: number,
  resolution: number,
  width?: string | number | string[] | number[],
  height?: string | number | string[] | number[],
  focalPoint?: FocalPoint,
  imageProcessorParams?: ImageProcessorParams | ImageProcessorParams[]
): ImageProcessorParams => ({
  ...(width && Array.isArray(width) && width[breakpointIndex]
    ? {
        width: calculateResolutionSize(
          (width as Array<string | number>)[breakpointIndex],
          resolution
        )
      }
    : width &&
      !Array.isArray(width) && {
        width: calculateResolutionSize(width as string | number, resolution)
      }),

  ...(height && Array.isArray(height) && height[breakpointIndex]
    ? {
        height: calculateResolutionSize(
          (height as Array<string | number>)[breakpointIndex],
          resolution
        )
      }
    : height &&
      !Array.isArray(height) && {
        height: calculateResolutionSize(height as string | number, resolution)
      }),

  // If props.imageProcessorParams is a theme-ui responsive array, find the value in the array matching the current breakpoint
  // otherwise it's a single value. This makes up the rest of the base query parameters and allows users of the component to use
  // the ImageProcessor capabilities
  ...(imageProcessorParams &&
  Array.isArray(imageProcessorParams) &&
  imageProcessorParams[breakpointIndex]
    ? {
        ...imageProcessorParams[breakpointIndex]
      }
    : imageProcessorParams &&
      !Array.isArray(imageProcessorParams) && {
        ...imageProcessorParams
      }),

  // If focal point exists ad crop mode with focal points to place crop center
  ...(focalPoint && {
    mode: "crop",
    center: `${focalPoint.top},${focalPoint.left}`
  })
});
